import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DSRESTClient } from '../shared/communication-objects/restclient.service';
import { api } from '../shared/communication-objects/api-path';

@Injectable()
export class TankViewProfileService {

  private apiURL = api`TankViewProfile`;

  constructor(
    private restClient: DSRESTClient,
    private httpClient: HttpClient) { }


  getTvpSimpleList(): Observable<any> {
    let allTvps = this.restClient.get<any>(api`${this.apiURL}/GetListOfUserTvps`);
    return allTvps;
  }

  getAllTvps(): Observable<any> {
    let allTvps = this.restClient.get<any>(api`${this.apiURL}/GetUsersTvps`);
    return allTvps;
    }

  getLastSelectedTvp(): Observable<any> {
    let tvp = this.restClient.get<any>(api`${this.apiURL}/GetLastSelectedTvp`);
    return tvp;
  }
}
